module.exports = __webpack_public_path__ + "static/media/Web 1920 – 1.a1b45a73.png";